import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import AdminHeader from "./AdminHeader";
import AdminSidebar from "./AdminSidebar";
import { useAuth } from "../../context/AuthContext";

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const { user } = useAuth();

  const getPageTitle = () => {
    const path = location.pathname;

    if (path === "/admin-dashboard" || path === "/admin-dashboard/") return "Dashboard Overview";
    if (path.includes("/flagged")) return "Flagged Issues";
    if (path.includes("/users")) return "Users";
    if (path.includes("/issues")) return "Issues";
    if (path.includes("/claims")) return "Claims";
    if (path.includes("/analytics")) return "Analytics";
    if (path.includes("/settings")) return "Settings";

    return "Admin Dashboard";
  };

  return (
    <div className="min-h-screen bg-[#f5f7f2] text-slate-900">
      <div className="pointer-events-none fixed inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(255,153,51,0.12),_transparent_28%),radial-gradient(circle_at_bottom_right,_rgba(19,136,8,0.12),_transparent_28%)]" />
      <AdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div className="relative lg:ml-72">
        <AdminHeader
          onMenuClick={() => setSidebarOpen(true)}
          title={getPageTitle()}
          user={user}
        />

        <main className="p-4 sm:p-6 lg:p-8">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>

        <footer className="border-t border-[#d7dfd4] px-6 py-5 text-center text-sm text-slate-500">
          <p>JanShakti Admin Workspace</p>
          <p className="mt-1">© {new Date().getFullYear()} JanShakti. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default AdminLayout;
